<template>
    <section class="featured-products">
      <div class="container">
        <h2 class="section-title">Featured Products</h2>
        <div class="product-grid">
          <ProductCard 
            v-for="product in featuredProducts" 
            :key="product.id" 
            :product="product" 
          />
        </div>
        <div class="view-more">
          <router-link to="/products" class="btn-secondary">View All Products</router-link>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import ProductCard from './ProductCardComponent.vue'
  
  export default {
    name: 'FeaturedProducts',
    components: {
      ProductCard
    },
    data() {
      return {
        featuredProducts: [
          {
            id: 1,
            name: 'Smartphone Pro Max',
            image: '../../assets/images/placeholder.svg?height=200&width=200',
            price: 899,
            oldPrice: 999,
            rating: 4.5,
            reviewCount: 120,
            badge: 'New'
          },
          {
            id: 2,
            name: 'Wireless Headphones',
            image: '../../assets/images/placeholder.svg?height=200&width=200',
            price: 159,
            oldPrice: 199,
            rating: 5,
            reviewCount: 85,
            badge: 'sale'
          },
          {
            id: 3,
            name: 'Smart Watch Series 5',
            image: '../../assets/images/placeholder.svg?height=200&width=200',
            price: 299,
            rating: 4,
            reviewCount: 42
          },
          {
            id: 4,
            name: 'Laptop Pro 16"',
            image: '../../assets/images/placeholder.svg?height=200&width=200',
            price: 1499,
            oldPrice: 1699,
            rating: 5,
            reviewCount: 215,
            badge: 'Bestseller'
          }
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  .featured-products {
    padding: 60px 0;
    background-color: var(--white);
  }
  
  .product-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
  }
  
  .view-more {
    text-align: center;
    margin-top: 40px;
  }
  
  @media (max-width: 1200px) {
    .product-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  @media (max-width: 992px) {
    .product-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (max-width: 768px) {
    .product-grid {
      grid-template-columns: 1fr;
    }
  }
  </style>